import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Axios from "axios";
import Swal from 'sweetalert2';
import LoadingSpinner from "../helpers/loadingspinner";
import { useForm,Controller } from "react-hook-form";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import WYSIWYGEditor from "../helpers/WYSIWYGEditor"
import { useCountry } from "../contexts/countrycodecontext.js";
import { GetInterviewQuestionbyQuestionID, GetJobRoles, GetTestTypes, UpdateQuestionsByQuestionID } from "../apiconstants/constants";

const EditQuestions = () => {
    const { register,handleSubmit,control,setValue,formState: { errors, isSubmitting }, reset } = useForm();
    const { qGuid } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");
    const [jobRoleID, setJobRoleID] = useState("");
    const [testTypeID, setTestTypeID] = useState("");
    const [jobRoles, setJobRoles] = useState([]);
    const [testTypes, setTestTypes] = useState([]);
    const {selectedCountry} = useCountry();
    let Guid="";
    const guid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const token = localStorage.getItem("jwtToken");
    const roleID = localStorage.getItem("roleID")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= guid
    }
    
    useEffect(() => {
        const fetchQuestion = async () => {
            try {
                setIsLoading(true);
                const response = await Axios.get(`${GetInterviewQuestionbyQuestionID.APIURL, {
    headers: {
      "Authorization": `Bearer ${token}`,     
    }
  }}/${qGuid}`);
                const { question, jobRoleID, testTypeID,answer } = response.data[0]; // Assuming response.data is an array with a single object
                setValue("question",response.data[0].question)
                setValue("answer",response.data[0].answer)
                setJobRoleID(jobRoleID.toString()); // Convert jobRoleID to string if necessary
                setTestTypeID(testTypeID.toString()); // Convert testTypeID to string if necessary
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching question", error);
                setIsLoading(false);
            }
        };

        const fetchJobRoles = async () => {
            try {
                const response = await Axios.get(`${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`);
                setJobRoles(response.data);
            } catch (error) {
                console.error("Error fetching job roles", error);
            }
        };

        const fetchTestTypes = async () => {
            try {
                const response = await Axios.get(GetTestTypes.APIURL,{headers: { Authorization: `Bearer ${token}` } });
                setTestTypes(response.data);
            } catch (error) {
                console.error("Error fetching test types", error);
            }
        };

        fetchQuestion();
        fetchJobRoles();
        fetchTestTypes();
    }, [qGuid, selectedCountry]);

    const onSubmit = async (data,e) => {
        e.preventDefault();
        setIsLoading(true);

       
        try {
            const params= {
            "question": data.question,
            "updatedBy": email,
            "testTypeID":testTypeID,
            "answer": data.answer,
            "jobRoleID": jobRoleID,
            "qGuid": qGuid,
            "countryID":selectedCountry

        }
            const response = await Axios.post(UpdateQuestionsByQuestionID.APIURL,params,{ headers: { Authorization: `Bearer ${token}` } });
            setIsLoading(false);
           if(response.data==="Updated successfully"){
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Updated successfully',
                showConfirmButton: false,
                timer: 5000
            });
        }
            navigate("/Employer/Questions");
        } catch (error) {
            console.error("Error updating question", error);
            setIsLoading(false);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Failed to Update Question',
                showConfirmButton: false,
                timer: 5000
            });
        }
    };

  

    if (isLoading) {
        return <LoadingSpinner />;
    }

    return (
        <ConsultantLayout>
            
            <section>

                <div className="container-fluid mt-4 pb-5">
                <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/Questions">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Edit Question</h2>
</div>
                            <hr />
                            <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group">
                        <label style={{color:"#00a7ac"}}>Enter the Question</label>
                        <Controller
        control={control}
        name="question"
        rules={{
          required: { value: true, message: "Question Required" },
        }}
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <div>
            <WYSIWYGEditor
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              ref={ref}
              inputExtraProps={{
                required: true,
              }}
            />
            {errors.question && (
              <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                {errors.question.message}
              </p>
            )}
          </div>
        )}
      />
                           
                        </div>
                        <div className="form-group">

                        <label style={{color:"#00a7ac"}}>Enter the Answer</label>
<Controller
        control={control}
        name="answer"
        rules={{
          required: { value: true, message: "Answer Required" },
        }}
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <div>
            <WYSIWYGEditor
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              ref={ref}
              inputExtraProps={{
                required: true,
              }}
            />
            {errors.answer && (
              <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                {errors.answer.message}
              </p>
            )}
          </div>
        )}
      />
                        </div>
                        <div className="form-group">
                        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>

                            <select
                                id="jobRoleID"
                                className="form-control basic-form"
                                value={jobRoleID}
                                onChange={(e) => setJobRoleID(e.target.value)}
                            >
                                <option value="">Select Job Role</option>
                                {jobRoles.map((jobRole) => (
                                    <option key={jobRole.jobRoleId} value={jobRole.jobRoleId}>{jobRole.jobRole}</option>
                                ))}
                            </select>
                            </OverlayTrigger>
                        </div>
                        <div className="form-group">
                        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Test Type</Tooltip>)}>

                            <select
                                id="testTypeID"
                                className="form-control basic-form"
                                value={testTypeID}
                                onChange={(e) => setTestTypeID(e.target.value)}
                            >
                                <option value="">Select Test Type</option>
                                {testTypes.map((testType) => (
                                    <option key={testType.testTypeID} value={testType.testTypeID}>{testType.testType}</option>
                                ))}
                            </select>
                            </OverlayTrigger>
                        </div>
                        
                        <div className="row mt-4 p-0">
            <div className="col-12">
            <Link to="/Employer/Questions"> 
             <button style={{ float: "right" }}className="btn btn-primary ">
                        Cancel
                      </button>
                      </Link>
              <button style={{float:"right"}} className="btn btn-primary mr-3">
                Update
              </button> 
            </div>
        </div>
                    </form>
                    </div>
                    </div>
                </div>
               
            </section>
        </ConsultantLayout>
    );
};

export default EditQuestions;
